// One public catalog reader. The challenge gateway owns its result and passes
// it to registration; standalone consumers may make their own fresh read.
export const readPublicChallengeCatalog = async (apiUrl) => {
  const response = await fetch(
    `${apiUrl}/courses/session-groups?active=true&registrationAccess=public&limit=50`,
  );
  if (!response.ok) throw new Error(`session_groups_${response.status}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.sessionGroups || data.data || [];
};
